// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"/themes/martfury/js/main": 0,
	"vendor/core/plugins/social-login/css/social-login": 0,
	"vendor/core/plugins/translation/css/translation": 0,
	"themes/martfury/css/rtl": 0,
	"themes/martfury/css/style": 0,
	"vendor/core/core/base/css/libraries/select2.rtl": 0,
	"vendor/core/core/base/css/core.rtl": 0,
	"vendor/core/core/base/css/crop-image": 0,
	"vendor/core/core/base/css/tree-category": 0,
	"vendor/core/core/base/css/error-pages": 0,
	"vendor/core/core/base/css/libraries/select2": 0,
	"vendor/core/core/base/css/core": 0,
	"vendor/core/core/media/css/media": 0,
	"vendor/core/core/setting/css/admin-email": 0,
	"vendor/core/core/table/css/table": 0,
	"vendor/core/packages/get-started/css/get-started": 0,
	"vendor/core/packages/installer/css/style": 0,
	"vendor/core/packages/menu/css/menu": 0,
	"vendor/core/packages/revision/css/revision": 0,
	"vendor/core/packages/seo-helper/css/seo-helper": 0,
	"vendor/core/packages/shortcode/css/shortcode": 0,
	"vendor/core/packages/slug/css/slug": 0,
	"vendor/core/packages/theme/css/guideline": 0,
	"vendor/core/packages/theme/css/admin-bar": 0,
	"vendor/core/packages/theme/css/theme-options": 0,
	"vendor/core/packages/widget/css/widget": 0,
	"vendor/core/plugins/backup/css/backup": 0,
	"vendor/core/plugins/contact/css/contact-public": 0,
	"vendor/core/plugins/contact/css/contact": 0,
	"vendor/core/plugins/cookie-consent/css/cookie-consent": 0,
	"vendor/core/plugins/ecommerce/css/front-theme-rtl": 0,
	"vendor/core/plugins/ecommerce/css/front-theme": 0,
	"vendor/core/plugins/ecommerce/css/front-review": 0,
	"vendor/core/plugins/ecommerce/css/front-faq": 0,
	"vendor/core/plugins/ecommerce/css/front-ecommerce-rtl": 0,
	"vendor/core/plugins/ecommerce/css/front-ecommerce-missing-bootstrap": 0,
	"vendor/core/plugins/ecommerce/css/front-ecommerce": 0,
	"vendor/core/plugins/ecommerce/css/front-auth": 0,
	"vendor/core/plugins/ecommerce/css/widget": 0,
	"vendor/core/plugins/ecommerce/css/order-return": 0,
	"vendor/core/plugins/ecommerce/css/report": 0,
	"vendor/core/plugins/ecommerce/css/customer": 0,
	"vendor/core/plugins/ecommerce/css/review": 0,
	"vendor/core/plugins/ecommerce/css/currencies": 0,
	"vendor/core/plugins/ecommerce/css/ecommerce-product-attributes": 0,
	"vendor/core/plugins/ecommerce/css/ecommerce": 0,
	"vendor/core/plugins/faq/css/faq": 0,
	"vendor/core/plugins/language/css/language-public": 0,
	"vendor/core/plugins/language/css/language": 0,
	"vendor/core/plugins/marketplace/css/marketplace-rtl": 0,
	"vendor/core/plugins/marketplace/css/marketplace": 0,
	"vendor/core/plugins/newsletter/css/newsletter": 0,
	"vendor/core/plugins/payment/css/payment-setting": 0,
	"vendor/core/plugins/payment/css/payment": 0,
	"vendor/core/plugins/simple-slider/css/simple-slider": 0
};

// no chunk on demand loading

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);

// install a JSONP callback for chunk loading
var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = self["webpackChunk"] = self["webpackChunk"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));